<template>

  <HeaderSection />

  <section id="formulario" class="bg-[#153244] py-10" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 w-full md:max-w-6xl bg-white rounded-lg p-10">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center ">
          ACREDITACIÓN DE EXPOSITORES
        </h1>
        <h1 class="text-gray-800 text-center">
          Si ya se acreditó y no le llegó el correo puede descargar su QR haciendo <router-link to="/credenciales" class="underline">click aquí</router-link>
        </h1>
        <h1 class="text-gray-800 text-2xl text-center mt-5">
          Por favor complete el formulario en su totalidad
        </h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">DNI</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric" @blur="validarDni" placeholder="DNI" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text"  placeholder="Nombre"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text"  placeholder="Apellido"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>


        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text"  placeholder="Empresa"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text"  placeholder="Cargo"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text"  placeholder="Mail"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País (celular)</label>
              <Select v-model="selectedCountry" :options="paises" optionLabel="descripcion" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.id" class="input-base input-success" readonly />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text"  class="input-base"  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-[#153244] hover:bg-[#153244] text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import HeaderSection from './HeaderSection.vue';
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import Select from 'primevue/select';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado, StringIdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais  extends StringIdLabelEntity {}

export default defineComponent({
  components: {
    HeaderSection,
    InputText, Select, BlockUI,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "EXPOSEG 2025  - Expositor";
  },
  data() {
    return {
      isSubmitting: false,
      paises: [] as Pais[],
      selectedCountry: {"id": "+54", "descripcion": "Argentina"} as Pais,
      formData: {
        documento: '',
        nombre: '',
        apellido: '',
        empresa: '',
        cargo: '',
        mail:  '',
        codigoArea: '',
        telefonoCelular: '',        
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 7 números'),
        empresa: yup.string().required('Ingrese su empresa').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido')        
      });
    }
  },
  methods: {
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
        if (acreditadoExistente) {
          this.isSubmitting = false;
          Swal.fire({ 
              title: "Atención", 
              html: "El DNI ingresado ya fue registrado.<br/><br/>Le enviamos un mail con su QR de accesos<br/><br/>Por favor revise su casilla de correo y de spam.<br/><br/>También puede descarga su QR haciendo <a href='/credenciales'>click aquí</a>",
              icon: "warning" }).then(() => {
                window.location.href = "https://www.exposegba.com.ar";
          });
          return;
        }
      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },    
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      console.log(values?.errors);
      Swal.fire({ title: "Error", html: "Por favor revise el formulario<br/>Hay error/es (" + errores + ")", icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        this.isSubmitting = false;

        Swal.fire({ 
            title: "Atención", 
            html: "El DNI / Pasaporte ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "warning" 
          });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 1674 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.dni = this.formData.documento;
      acreditado.empresa = this.formData.empresa;
      acreditado.cargo = this.formData.cargo;
      acreditado.mail = this.formData.mail;      
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.telefono = this.selectedCountry.id + this.formData.codigoArea + this.formData.telefonoCelular;

      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false; 

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Su registro se realizó con éxito.<br/><br/>Una vez validada su acreditación recibirá un mail para poder descargarse su credencial.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://www.exposegba.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.paises = jsonCountries;
  }

});
</script>
